import { Outlet } from 'react-router-dom';
import Header from './Header';
import InstallPrompt from '../ui/InstallPrompt';

export default function Layout() {
  return (
    <div className="min-h-screen bg-gray-950 text-gray-50">
      <Header />
      <main>
        <Outlet />
      </main>
      <footer className="border-t border-gray-800 py-8 mt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-gray-500 text-sm">
          &copy; {new Date().getFullYear()} Nokset. All rights reserved.
        </div>
      </footer>
      <InstallPrompt />
    </div>
  );
}
